module.exports = __webpack_public_path__ + "img/icon_lots_pod_buy.9eeabdb9.png";